<template>
	<svg t="1681981851471" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4864" width="100" height="100"><path d="M320 128 254.656 128 0 128l0 62.016L0 448l128 0 0 64 128 0 0 128 768 0L1024 128 320 128zM192 448 192 384 128 384 64 384 64 192l192 0 0 256L192 448zM960 576 320 576 320 512l0 0 640 0L960 576zM960 448 320 448 320 320 320 192l640 0L960 448z" p-id="4865"></path></svg>
</template>
<script>
	export default {
		name : "icon-channel",
	}
</script>